module.exports = __webpack_public_path__ + "img/redI.b75fc511.svg";